export function languages() {
  return [
    { title: "ru", value: "ru" },
    { title: "kz", value: "kz" },
    { title: "mx", value: "mx" },
  ];
}

export function timeNormalizer(timeInSeconds) {
  if (timeInSeconds == null || isNaN(timeInSeconds) || timeInSeconds < 0) {
    return "00:00:00";
  }

  const total = Math.floor(timeInSeconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return [hours, minutes, seconds]
    .map((v) => String(v).padStart(2, "0"))
    .join(":");
}

export function timeShortHuman(seconds) {
  if (seconds == null || isNaN(seconds) || seconds < 0) return "";

  const oneMinute = 60;
  const oneHour = 3600;
  const oneDay = 86400;

  function plural(value, one, few, many) {
    const v = Math.abs(value);
    const mod10 = v % 10;
    const mod100 = v % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
    return many;
  }

  if (seconds < oneMinute) {
    const s = +seconds.toFixed(2);
    const sClean = String(s).replace(/\.0$/, "");
    return `${sClean} ${plural(sClean, "секунда", "секунды", "секунд")}`;
  }

  if (seconds < oneHour) {
    const m = +(seconds / oneMinute).toFixed(2);
    return `${m} ${plural(m, "минута", "минуты", "минут")}`;
  }

  if (seconds < oneDay) {
    const h = +(seconds / oneHour).toFixed(2);
    return `${h} ${plural(h, "час", "часа", "часов")}`;
  }

  const d = +(seconds / oneDay).toFixed(2);
  return `${d} ${plural(d, "день", "дня", "дней")}`;
}
